/**
 * @generated SignedSource<<f6d788454bb0ee15e37b3e1387a45bff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkspaceMembersPageResendMutation$variables = {
  inviteId: string;
};
export type WorkspaceMembersPageResendMutation$data = {
  readonly resendWorkspaceInvite: {
    readonly expiresAt: string;
    readonly id: string;
  };
};
export type WorkspaceMembersPageResendMutation = {
  response: WorkspaceMembersPageResendMutation$data;
  variables: WorkspaceMembersPageResendMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "inviteId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "inviteId",
        "variableName": "inviteId"
      }
    ],
    "concreteType": "WorkspaceInvite",
    "kind": "LinkedField",
    "name": "resendWorkspaceInvite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceMembersPageResendMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceMembersPageResendMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f75f99800798b3f7eeaea61f42b5525c",
    "id": null,
    "metadata": {},
    "name": "WorkspaceMembersPageResendMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceMembersPageResendMutation(\n  $inviteId: ID!\n) {\n  resendWorkspaceInvite(inviteId: $inviteId) {\n    id\n    expiresAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa3f157b4bc4144aaf8fe8dc6b49aa1e";

export default node;
